import { Injectable, Injector } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class DashboardTitleStrategy extends TitleStrategy {
	private translateService: TranslateService | null = null;

	constructor (
		private readonly titleService: Title,
		private readonly injector: Injector
	) {
		super();
	}

	public override updateTitle (routerState: RouterStateSnapshot): void {
		const titleKey = this.buildTitle(routerState);
		if (titleKey == null) {
			return;
		}

		const translateService = this.getTranslateService();
		const pageTitle = translateService.instant(titleKey);
		this.titleService.setTitle(
			translateService.instant('document-title_page', { name: pageTitle })
		);
	}

	private getTranslateService (): TranslateService {
		if (this.translateService == null) {
			// We need to use the injector here to avoid a circular dependency in the router
			this.translateService = this.injector.get(TranslateService);
		}

		return this.translateService;
	}
}
